@if (permissionType === Type.USER) {
  <ziro-typeahead fieldId="name"></ziro-typeahead>
} @else {
  <ziro-select fieldId="name"></ziro-select>
}

@if (permissionType === Type.GROUP) {
  <div class="row mb-3">
    <div class="col-lg-3 text-end">
      <label class="col-form-label">{{ 'tkey;admin.system.user_permissions.members.label' | translate }}</label>
    </div>
    <div class="col-lg-4">
      <ziro-view-members
        [members]="usersInGroup"
        [state]="viewMembersState"
        [disabled]="usersInGroup.length === 0"
      ></ziro-view-members>
    </div>
  </div>
}

<ziro-radio [fieldId]="'role'"></ziro-radio>
<ziro-select [fieldId]="'permittedDialPlanGroups'"></ziro-select>

<ng-template #errorTemplate>
  @if (isFormSubmitted && validationState === ValidationState.INVALID) {
    <span>
      {{ 'tkey;validators.global.required.missing.error' | translate }}
    </span>
  }
</ng-template>
